var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import BusinessUnit, { makeid } from './Model';
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            _this.data = values.map(function (item) { return new BusinessUnit(item); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (value) {
            _this.data.push(new BusinessUnit(value));
            return _this.data;
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
            return _this.data;
        };
        this.splice = function (value) {
            console.log(value);
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value; }), 1);
            return _this.data;
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('BusinessUnits/Store - read')
        if (id)
            return api.get('businessunits/' + id).then(function (value) {
                // console.log('BusinesUnits/Store - read(id) - value: ', value)
                value.image = value.image + '?dummy=' + makeid(3);
                return value;
                // return new BusinessUnit(value)
            });
        return api.get('businessunits').then(function (value) {
            // console.log('value', value)
            return _this.set(value);
            // return value
        });
    };
    default_1.prototype.create = function (value) {
        return api.post('businessunits', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        return api.put('businessunits/' + id, value).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('businessunits/' + id, { disabled: disabled }).then(this.pull);
    };
    default_1.prototype.delete = function (id) {
        return api.delete('businessunits/' + id).then(this.splice);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "splice", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/BusinessUnits/Store.ts
// module id = 707
// module chunks = 0